import { type ReactNode } from "react";
import {
    AccordionHeader,
    AccordionItem,
    AccordionPanel,
    AccordionTrigger,
} from "@design-system/Accordion/Accordion";
import { ArrowDownIcon } from "@icons";
import styles from "./ScheduleManualModal.module.scss";

interface ScheduleManualSectionProps {
    value: string;
    label: string;
    /** Controls beside the title that act without toggling the section. */
    headerActions?: ReactNode;
    children: ReactNode;
}

export const ScheduleManualSection = ({
    value,
    label,
    headerActions,
    children,
}: ScheduleManualSectionProps) => (
    <AccordionItem value={value} className={styles.sectionCard}>
        <div className={styles.sectionHeader}>
            <AccordionHeader>
                <AccordionTrigger className={styles.sectionTrigger}>
                    {label}
                    <ArrowDownIcon
                        aria-hidden
                        className={styles.sectionTriggerIcon}
                    />
                </AccordionTrigger>
            </AccordionHeader>
            {headerActions && (
                <div className={styles.sectionHeaderActions}>
                    {headerActions}
                </div>
            )}
        </div>
        <AccordionPanel>
            <div className={styles.sectionContent}>{children}</div>
        </AccordionPanel>
    </AccordionItem>
);

export const ScheduleManualStaticSection = ({
    label,
    children,
}: {
    label: string;
    children: ReactNode;
}) => (
    <section className={styles.sectionCard}>
        <h3 className={styles.sectionTitle}>{label}</h3>
        <div className={styles.sectionContent}>{children}</div>
    </section>
);
